import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-wallet-icon',
  templateUrl: './wallet-icon.component.html',
})

export class WalletIconComponent {
  @Input() color: string = '';
}
